import { Text, Tooltip } from "@mantine/core";
import { type CellContext } from "@tanstack/react-table";

import { CompetencyBadge, NotAsked } from "@/components/upwage-badge";
import { useGetInternalOnlyRender } from "@/hooks/use-internal-only-render";
import {
  type Competency,
  CompetencyFit,
  type Screening,
} from "@/types/screeners";
import { getCompetencyBadgeWidth } from "@/utils/competency";
import { renderRawScore } from "@/utils/ui";

interface CompetencyCellProps {
  info: CellContext<Screening, Competency>;
}

export const CompetencyCell = ({ info }: CompetencyCellProps) => {
  const internalOnlyRender = useGetInternalOnlyRender();
  const competency = info.getValue();

  if (!competency) {
    return null;
  }

  const { quote, rawScore, score } = competency;
  const rawScoreUI = renderRawScore(internalOnlyRender, rawScore);

  if (score === CompetencyFit.NotAsked) {
    return <NotAsked />;
  }

  if (!score) {
    return;
  }

  return (
    <Tooltip
      label={
        <Text size="sm" c="black">
          {quote || "No available quote for this competency."}
        </Text>
      }
      multiline
      withArrow
      arrowSize={8}
      w={400}
      color="white"
      classNames={{ tooltip: "border border-gray-200 z-[1000]" }}
    >
      <CompetencyBadge
        className={getCompetencyBadgeWidth(!!rawScoreUI)}
        rawScore={rawScore}
        score={score}
      />
    </Tooltip>
  );
};
